import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthState } from 'services/redux/authSlice';

import { usePaymentRequestPassiveCheckboxes } from '../hooks/usePaymentRequestPassiveCheckboxes';
import { PaymentRequestPassiveExportRequest } from '../PaymentRequestPassiveReportGenerator';
import { handleExportPaymentRequestPassive } from '../utils/exportPaymentRequestPassive';
import { PaymentRequestPassiveCheckboxes } from './PaymentRequestPassiveCheckboxes';

interface ExportDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedRequest: PaymentRequestPassiveExportRequest;
  canShowPayouts?: boolean;
}

const ExportDialog: React.FC<ExportDialogProps> = ({
  open,
  setOpen,
  selectedRequest,
  canShowPayouts = false,
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [checkboxes, setters] = usePaymentRequestPassiveCheckboxes();
  const [loading, setLoading] = useState(false);

  const requestId = selectedRequest.id || selectedRequest.sourceId;

  const onExport = async () => {
    setLoading(true);
    try {
      const request: PaymentRequestPassiveExportRequest = {
        ...selectedRequest,
        ...checkboxes,
      };

      await handleExportPaymentRequestPassive({
        dispatch,
        user,
        request,
        checkboxes,
        canShowPayouts,
      });

      setOpen(false);
    } catch (error) {
      // Error ya manejado en handleExportPaymentRequestPassive
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>
        Exportar liquidación devolución de pasivos{' '}
        {requestId && <strong>#{requestId}</strong>}
      </DialogTitle>
      <DialogContent>
        {loading && (
          <div style={{ minHeight: 200, minWidth: 500 }}>
            <CenteredCircularProgress type="dialog" />
          </div>
        )}
        {!loading && (
          <div>
            <Typography>
              Selecciona qué elementos incluir en el documento PDF.
            </Typography>
            <PaymentRequestPassiveCheckboxes
              checkboxes={checkboxes}
              setters={setters}
              canShowPayouts={canShowPayouts}
            />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpen(false)}>
          Cancelar
        </CustomButton>
        <CustomButton color="primary" onClick={onExport} loading={loading}>
          Exportar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ExportDialog;
